export class AppointmentFormFieldKeys {
  constructor() {
    return {
      addressPatient: null,
      applicationDate: null,
      applicationThrough: null,
      birthDatePatient: null,
      createdBy: null,
      emailPatient: null,
      firstNamePatient: null,
      lastNamePatient: null,
      phonePatient: null,
      policyNumber: null,
      doctorId: null,
      selfPay: false,
      agendaSlotId: null
      // comment: null
    };
  }
}
